import React, { Component } from 'react';

import { withRouter, Link } from 'react-router-dom';
import CityDropdown from './CityDropdown';
import NavbarGeneralVehicles from './NavbarGeneralVehicles';
import NavbarGeneralCities from './NavbarGeneralCities';
import './navbarGeneral.css';
import { loadState, saveState } from '../../utils/localStorage';

class NavbarGeneral extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  renderVehicleTypes = () => {};
  render() {
    const { closeDrawer, history } = this.props;
    return history.location.pathname === '/downloadapp' ? null : (
      <div className="navbar--regular-weight">
        <NavbarGeneralVehicles closeDrawer={closeDrawer} />
       {loadState()?
       <ul className="head nav navbar-nav links-right">
       {/* <CityDropdown closeDrawer={closeDrawer} /> */}
        {!history.location.pathname.includes('signup') && (
          <NavbarGeneralCities />
        )}
          <li>
            <Link
              className="navbar--regular-weight navbar--tight-margin"
              to="/userpage">
              Profile
            </Link>
          </li>
          <li>
            <Link
              className="navbar--regular-weight navbar--tight-margin"
              to="/signout">
              Log out
            </Link>
          </li>
       </ul>
       :
        <ul className="head nav navbar-nav links-right">
          {/* <CityDropdown closeDrawer={closeDrawer} /> */}
          {!history.location.pathname.includes('signup') && (
            <NavbarGeneralCities />
          )}
          <li>
            <Link
              className="navbar--regular-weight navbar--tight-margin"
              to="/login">
              Log In
            </Link>
          </li>
          <li>
            <Link
              className="navbar--regular-weight navbar--tight-margin"
              to="/signup">
              Sign Up
            </Link>
          </li>
        </ul>}
      </div>
    );
  }
}

export default withRouter(NavbarGeneral);



// WEBPACK FOOTER //
// ./src/components/Layout/NavbarGeneral.js